import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, Button } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import bottomSheetMobileInfoWindowStyles from './bottomSheetMobileInfoWindowStyles'
import {
  formatTimeString,
  scheduleToHumanReadable,
  setPolylineStyle,
} from '../../../utils/helpers'
import {
  setActiveLotId,
  setDestination,
  setDirectionRoutes,
  setLatLang,
  setMarkerInfo,
  setOrigin,
  showDirections,
} from '../../../sections/Map/redux/myMapsSlice'
import NavigationContent from '../../../sections/Map/components/MapInfoWindow/NavigationContent'
import mapInfoWindowStyles from '../../../sections/Map/components/MapInfoWindow/mapInfoWindowStyles'
import {
  MapInfoNote,
  MapInfoTable,
  ParkingLotImageCarousel,
} from '../../../sections/Map/components/MapInfoWindow/MapInfoWindow'
import { selectDarkMode } from '../../../../settings/settingsSlice'

export default function BottomSheetMobileInfoWindow({
  setSheetConfig,
  parkingLotData,
  additionalFilters,
}) {
  const classes = bottomSheetMobileInfoWindowStyles()
  const { filters: filterBy, userParkingPermitData } = useSelector(
    (s) => s.maps,
  )
  const darkMode = useSelector(selectDarkMode)
  const styles = mapInfoWindowStyles()
  const [campusImage, setCampusImage] = React.useState(null)
  const [showNavigation, updateShowNavigation] = React.useState(false)
  const [userPermitHours, setUserPermitHours] = React.useState(null)
  const directionStepsRef = React.useRef(null)
  const dispatch = useDispatch()
  const {
    markerInfo,
    datasetLayer,
    destination,
    directionRoutes,
    directionsRenderer,
    zoom,
  } = useSelector((s) => s.maps)
  const chooseCampusImage = (markerLocation) => {
    let imageRef = null
    switch (markerLocation) {
      case 'NB':
        imageRef = {
          image: './assets/images/nb-campus.jpg',
          label: 'New Brunswick Campus',
        }
        break
      case 'NWK':
        imageRef = {
          image: './assets/images/nwk-campus.jpg',
          label: 'Newark Campus',
        }
        break
      case 'CAM':
        imageRef = {
          image: './assets/images/cmd-campus.jpg',
          label: 'Camden Campus',
        }
        break
      default:
        imageRef = {
          image: './assets/images/nb-campus.jpg',
          label: 'New Brunswick Campus',
        }
    }
    setCampusImage(imageRef)
  }
  const backButtonFunc = {
    myFunction() {
      dispatch(setMarkerInfo({}))
      dispatch(setOrigin(''))
      dispatch(setDestination(''))
      dispatch(showDirections(false))
      dispatch(setDirectionRoutes([]))
      dispatch(setActiveLotId(null))
      dispatch(
        setLatLang({
          lat: markerInfo?.location?.lat,
          lang: markerInfo?.location.lng,
          zoom,
        }),
      )
      updateShowNavigation(false)
      setUserPermitHours(null)
      datasetLayer.style = ({ feature }) =>
        setPolylineStyle({
          feature,
          parkingLotData,
          filterBy,
          additionalFilters,
        })
    },
  }
  const handleUpdateShowNavigation = () => {
    updateShowNavigation(!showNavigation)
  }
  const updateNavigationRoute = (index) => {
    directionsRenderer.setRouteIndex(index)
  }
  React.useEffect(() => {
    const sheetConfig = {
      title: markerInfo.propertyName,
      sheetColor: '',
      displayBackButton: false,
      displayCloseButton: true,
      backButtonFunc,
    }
    setSheetConfig(sheetConfig)
  }, [markerInfo])
  React.useEffect(() => {
    chooseCampusImage(markerInfo?.address?.regionCode)
    if (Object.keys(userParkingPermitData)?.length > 0) {
      const matchingGarage = userParkingPermitData?.garageIdInfo?.find(
        (garageObj) => garageObj?.garageId === markerInfo?.baseId,
      )
      // This will be the array of rules, or an empty array if no garage is found
      const hoursArray = matchingGarage ? matchingGarage.accessRules : []
      setUserPermitHours(hoursArray)
    }
    return () => {
      setUserPermitHours(null)
    }
  }, [markerInfo, userParkingPermitData])
  console.log('userPermitHours ', userPermitHours)
  return (
    <div className={classes.mobileInfoWindowContainer}>
      {showNavigation ? (
        <>
          <div style={{ width: '95dvw' }}>
            <NavigationContent
              dispatch={dispatch}
              classes={styles}
              showDirectionsButton={showNavigation}
              handleUpdateShowDirections={handleUpdateShowNavigation}
              destination={destination}
              directionRoutes={directionRoutes}
              updateNavigationRoute={updateNavigationRoute}
              directionStepsRef={directionStepsRef}
              propertyName={markerInfo.propertyName}
            />
          </div>
        </>
      ) : (
        <>
          <div className={classes.mobileMarkerInfoContainer}>
            <div className={classes.mapInfoCardContentContainer}>
              <MapInfoNote markerInfo={markerInfo} />
              <div style={{ marginTop: '10px' }}>
                <Typography variant="body1">
                  {`${markerInfo?.address?.address1}, ${markerInfo?.address?.cityCode}, NJ `}
                </Typography>
                <Typography variant="body1">
                  {markerInfo?.address?.campus}
                </Typography>
              </div>
              {userPermitHours && filterBy?.includes('permit') ? (
                <div className={classes.hoursContainer}>
                  <Typography
                    variant="h4"
                    component="h1"
                    style={{ fontWeight: 'bold', marginBottom: 5 }}
                  >
                    Permitted Hours
                  </Typography>
                  {userPermitHours?.map((hours, index) => (
                    // eslint-disable-next-line
                    <div key={index} style={{ marginBottom: 10 }}>
                      <Typography variant="body2">
                        {scheduleToHumanReadable(hours)}
                      </Typography>
                      <Typography variant="body2">{hours.name}</Typography>
                      <Typography variant="body2">
                        {formatTimeString(hours.enter)} to{' '}
                        {formatTimeString(hours.exit)}
                      </Typography>
                    </div>
                  ))}
                </div>
              ) : null}
              {markerInfo?.empHours && filterBy?.includes('Faculty/Staff') ? (
                <div className={classes.hoursContainer}>
                  <Typography
                    variant="h4"
                    component="h1"
                    style={{ fontWeight: 'bold', marginBottom: 5 }}
                  >
                    Employee Hours
                  </Typography>
                  <Typography variant="body2">
                    {markerInfo?.empHours.split('\n').map((line) => (
                      <React.Fragment key={line}>
                        <span>{line}</span>
                        <br />
                      </React.Fragment>
                    ))}
                  </Typography>
                </div>
              ) : null}
              <MapInfoTable
                classes={classes}
                markerInfo={markerInfo}
                darkMode={darkMode}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.getDirectionsButton}
                onClick={handleUpdateShowNavigation}
                style={{ marginTop: 5, marginBottom: 10 }}
              >
                Get Directions
              </Button>
              <div className={classes.campusImageContainer}>
                {campusImage ? (
                  <ParkingLotImageCarousel lot={markerInfo} classes={classes} />
                ) : (
                  <Skeleton width={350} height={154} />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
